module.exports = __webpack_public_path__ + "img/组 4.e68f155a.webp";